import { styled as muiStyled, Paper } from '@mui/material'

export const LocationStatsDialogPaper = muiStyled(Paper)(
  ({ theme }) => `
    max-width: 1200px !important;
    width: 100%;
    height: 100%;
`,
)

export const PatientsSelectHeaderContainer = muiStyled('div')(
  ({ theme, showAlways = false }) => `
  display: ${showAlways ? 'block' : 'none'};
  width: 100%;
  min-width: 280px;
  max-width: 400px;
  color: #000;
  @media(min-width: 900px){
    display: block;
  }
  @media(max-width: 768px){
    display: none;
  }
`,
)
